import { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from '@evertrue/et-components';

/**
 * Schedule step card for the cadence flow editor.
 * Allows setting a specific date/time for the next step.
 */
const ScheduleStepCard = ({ step, onUpdate, onDelete }) => {
  const [scheduleDate, setScheduleDate] = useState(step.scheduleDate || '');
  const [scheduleTime, setScheduleTime] = useState(step.scheduleTime || '');

  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setScheduleDate(newDate);
    onUpdate({ ...step, scheduleDate: newDate });
  };

  const handleTimeChange = (e) => {
    const newTime = e.target.value;
    setScheduleTime(newTime);
    onUpdate({ ...step, scheduleTime: newTime });
  };

  return (
    <div className="schedule-step-card">
      <div className="schedule-step-card--header">
        <div className="schedule-step-card--badge">
          <Icon icon="event" />
          <span>Schedule</span>
        </div>
        <Button type="simple" onClick={onDelete} title="Delete step">
          <Icon icon="delete" />
        </Button>
      </div>

      <div className="schedule-step-card--content">
        <p className="schedule-step-card--description">Wait until a specific date and time</p>
        <div className="schedule-step-card--inputs">
          <div className="schedule-step-card--field">
            <label className="schedule-step-card--label">Date</label>
            <input type="date" value={scheduleDate} onChange={handleDateChange} className="schedule-step-card--input" />
          </div>
          <div className="schedule-step-card--field">
            <label className="schedule-step-card--label">Time (optional)</label>
            <input type="time" value={scheduleTime} onChange={handleTimeChange} className="schedule-step-card--input" />
          </div>
        </div>
      </div>
    </div>
  );
};

ScheduleStepCard.propTypes = {
  step: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.string,
    scheduleDate: PropTypes.string,
    scheduleTime: PropTypes.string,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ScheduleStepCard;
